module.exports = __webpack_public_path__ + "79ada9d6b57b3ef105890975fbb794a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/lazard.png
// module id = 1693
// module chunks = 0